import React from 'react';
import classNames from 'classnames';

import './customButton.scss';

export const CustomButton = (props) => {
  const {
    title,
    variant = 'outlined',
    className,
    icon,
    iconPosition = 'left',
    color = '',
    ...rest
  } = props;

  const buttonStyles = classNames('button', {
    'button--outlined': variant === 'outlined',
    'button--filled': variant === 'filled',
    'button--red': color === 'red',
    'button--green': color === 'green',
    'button--default': color === 'default',
    [className ? className : '']: className,
  });

  return (
    <button className={buttonStyles} {...rest}>
      {iconPosition === 'left' && icon && (
        <div className="button__icon button__icon--left" style={!title ? { marginRight: 0 } : {}}>
          {icon}
        </div>
      )}
      {title ? title : null}
      {iconPosition === 'right' && icon && (
        <div className="button__icon button__icon--right">{icon}</div>
      )}
    </button>
  );
};
